"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = exports.Badge = exports.Avatar = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Avatar = exports.Avatar = _styledComponents["default"].div.withConfig({
  displayName: "Avatarstyle__Avatar",
  componentId: "sc-1mg5x37-0"
})(function (_ref) {
  var basic = _ref.basic,
    _ref$theme = _ref.theme,
    color = _ref$theme.color,
    spacing = _ref$theme.spacing;
  return {
    background: basic ? color.neutral['08'] : color.brandPrimary.light,
    borderRadius: '50%',
    color: basic ? color.brandPrimary.light : color.neutral['08'],
    width: spacing.inline['2xl'],
    height: spacing.inline['2xl'],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    userSelect: 'none'
  };
});
var Image = exports.Image = _styledComponents["default"].img.withConfig({
  displayName: "Avatarstyle__Image",
  componentId: "sc-1mg5x37-1"
})({
  borderRadius: '50%',
  objectFit: 'cover',
  width: '100%',
  height: '100%',
  color: 'transparent',
  textIndent: -10000
});
var Badge = exports.Badge = _styledComponents["default"].div.withConfig({
  displayName: "Avatarstyle__Badge",
  componentId: "sc-1mg5x37-2"
})(function (_ref2) {
  var _ref2$theme = _ref2.theme,
    color = _ref2$theme.color,
    shadow = _ref2$theme.shadow;
  return {
    background: color.brandSecondary.gradient,
    border: "1px solid ".concat(color.neutral['08']),
    borderRadius: '50%',
    boxShadow: shadow.level['04'],
    width: 14,
    height: 14,
    position: 'absolute',
    top: 0,
    right: 0
  };
});